export enum ELadderHologramBuildStep {
  LHBS_SnapToActor,
  LHBS_AdjustHeight,
}
